import { BaseApiClient } from './BaseApiClient';
import { IApiInterface } from './IApiConfig';
import { IAuthTokenBuilder } from './IAuthTokenBuilder';

export class WaitingListServiceClient extends BaseApiClient {
  public constructor(config: IApiInterface, fetch: any, authTokenBuilder: IAuthTokenBuilder,
                     googleAnalytics?: any) {
    super(config, fetch, authTokenBuilder, googleAnalytics);
  }

  public addToWaitingList = async (timeSlot: any, gymName: string) => {
    const request = await this.buildPostRequest('api/waiting-lists', {
      timeSlot,
      gymName,
    });
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }

  public removeFromWaitingList = async (waitlistEntry: any) => {
    const request = await this.buildDeleteRequest(`api/waiting-lists/${waitlistEntry.uid}`);
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }

  public getWaitingList = async () => {
    const request = await this.buildGetRequest('api/waiting-lists/mine');
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }

  public getWaitingListEntry = async (waitlistUid: string) => {
    const request = await this.buildGetRequest(`api/waiting-lists/${waitlistUid}`);
    const result = await this.fetch(request.url, request.options);
    const data = await this.assertHttp200AndGetJsonFromResult(result);
    return data;
  }
}
